// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * CKEditor 5 (v31.1.0) content styles.
 * Generated on Wed, 22 Dec 2021 12:18:23 GMT.
 * For more information, check out https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/content-styles.html
 */

:root {
  --ck-color-image-caption-background: hsl(0, 0%, 97%);
  --ck-color-image-caption-text: hsl(0, 0%, 20%);
  --ck-color-mention-background: hsla(341, 100%, 30%, 0.1);
  --ck-color-mention-text: hsl(341, 100%, 30%);
  --ck-color-table-caption-background: hsl(0, 0%, 97%);
  --ck-color-table-caption-text: hsl(0, 0%, 20%);
  --ck-highlight-marker-blue: hsl(201, 97%, 72%);
  --ck-highlight-marker-green: hsl(120, 93%, 68%);
  --ck-highlight-marker-pink: hsl(345, 96%, 73%);
  --ck-highlight-marker-yellow: hsl(60, 97%, 73%);
  --ck-highlight-pen-green: hsl(112, 100%, 27%);
  --ck-highlight-pen-red: hsl(0, 85%, 49%);
  --ck-image-style-spacing: 1.5em;
  --ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);
  --ck-todo-list-checkmark-size: 16px;
}

/* ckeditor5-image/theme/imagecaption.css */
.ck-content .image > figcaption {
  display: table-caption;
  caption-side: bottom;
  word-break: break-word;
  color: var(--ck-color-image-caption-text);
  background-color: var(--ck-color-image-caption-background);
  padding: 0.6em;
  font-size: 0.75em;
  outline-offset: -1px;
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-style-block-align-left,
.ck-content .image-style-block-align-right {
  max-width: calc(100% - var(--ck-image-style-spacing));
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-style-align-left,
.ck-content .image-style-align-right {
  clear: none;
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-style-side {
  float: right;
  margin-left: var(--ck-image-style-spacing);
  max-width: 50%;
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-style-align-left {
  float: left;
  margin-right: var(--ck-image-style-spacing);
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-style-align-center {
  margin-left: auto;
  margin-right: auto;
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-style-align-right {
  float: right;
  margin-left: var(--ck-image-style-spacing);
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-style-block-align-right {
  margin-right: 0;
  margin-left: auto;
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-style-block-align-left {
  margin-left: 0;
  margin-right: auto;
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content p + .image-style-align-left,
.ck-content p + .image-style-align-right,
.ck-content p + .image-style-side {
  margin-top: 0;
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-inline.image-style-align-left,
.ck-content .image-inline.image-style-align-right {
  margin-top: var(--ck-inline-image-style-spacing);
  margin-bottom: var(--ck-inline-image-style-spacing);
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-inline.image-style-align-left {
  margin-right: var(--ck-inline-image-style-spacing);
}
/* ckeditor5-image/theme/imagestyle.css */
.ck-content .image-inline.image-style-align-right {
  margin-left: var(--ck-inline-image-style-spacing);
}
/* ckeditor5-font/theme/fontsize.css */
.ck-content .text-tiny {
  font-size: 0.7em;
}
/* ckeditor5-font/theme/fontsize.css */
.ck-content .text-small {
  font-size: 0.85em;
}
/* ckeditor5-font/theme/fontsize.css */
.ck-content .text-big {
  font-size: 1.4em;
}
/* ckeditor5-font/theme/fontsize.css */
.ck-content .text-huge {
  font-size: 1.8em;
}
/* ckeditor5-highlight/theme/highlight.css */
.ck-content .marker-yellow {
  background-color: var(--ck-highlight-marker-yellow);
}
/* ckeditor5-highlight/theme/highlight.css */
.ck-content .marker-green {
  background-color: var(--ck-highlight-marker-green);
}
/* ckeditor5-highlight/theme/highlight.css */
.ck-content .marker-pink {
  background-color: var(--ck-highlight-marker-pink);
}
/* ckeditor5-highlight/theme/highlight.css */
.ck-content .marker-blue {
  background-color: var(--ck-highlight-marker-blue);
}
/* ckeditor5-highlight/theme/highlight.css */
.ck-content .pen-red {
  color: var(--ck-highlight-pen-red);
  background-color: transparent;
}
/* ckeditor5-highlight/theme/highlight.css */
.ck-content .pen-green {
  color: var(--ck-highlight-pen-green);
  background-color: transparent;
}
/* ckeditor5-horizontal-line/theme/horizontalline.css */
.ck-content hr {
  margin: 15px 0;
  height: 4px;
  background: hsl(0, 0%, 87%);
  border: 0;
}
/* ckeditor5-image/theme/image.css */
.ck-content .image {
  display: table;
  clear: both;
  text-align: center;
  margin: 0.9em auto;
  min-width: 50px;
}
/* ckeditor5-image/theme/image.css */
.ck-content .image img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  min-width: 100%;
}
/* ckeditor5-image/theme/image.css */
.ck-content .image-inline {
  /*
     * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).;
     * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.
     * This strange behavior does not happen with inline-flex.
     */
  display: inline-flex;
  max-width: 100%;
  align-items: flex-start;
}
/* ckeditor5-image/theme/image.css */
.ck-content .image-inline picture {
  display: flex;
}
/* ckeditor5-image/theme/image.css */
.ck-content .image-inline picture,
.ck-content .image-inline img {
  flex-grow: 1;
  flex-shrink: 1;
  max-width: 100%;
}
/* ckeditor5-image/theme/imageresize.css */
.ck-content .image.image_resized {
  max-width: 100%;
  display: block;
  box-sizing: border-box;
}
/* ckeditor5-image/theme/imageresize.css */
.ck-content .image.image_resized img {
  width: 100%;
}
/* ckeditor5-image/theme/imageresize.css */
.ck-content .image.image_resized > figcaption {
  display: block;
}
/* ckeditor5-block-quote/theme/blockquote.css */
.ck-content blockquote {
  overflow: hidden;
  padding-right: 1.5em;
  padding-left: 1.5em;
  margin-left: 0;
  margin-right: 0;
  font-style: italic;
  border-left: solid 5px hsl(0, 0%, 80%);
}
/* ckeditor5-block-quote/theme/blockquote.css */
.ck-content[dir="rtl"] blockquote {
  border-left: 0;
  border-right: solid 5px hsl(0, 0%, 80%);
}
/* ckeditor5-basic-styles/theme/code.css */
.ck-content code {
  background-color: hsla(0, 0%, 78%, 0.3);
  padding: 0.15em;
  border-radius: 2px;
}
/* ckeditor5-table/theme/tablecaption.css */
.ck-content .table > figcaption {
  display: table-caption;
  caption-side: top;
  word-break: break-word;
  text-align: center;
  color: var(--ck-color-table-caption-text);
  background-color: var(--ck-color-table-caption-background);
  padding: 0.6em;
  font-size: 0.75em;
  outline-offset: -1px;
}
/* ckeditor5-table/theme/table.css */
.ck-content .table {
  margin: 0.9em auto;
  display: table;
}
/* ckeditor5-table/theme/table.css */
.ck-content .table table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  height: 100%;
  border: 1px double hsl(0, 0%, 70%);
}
/* ckeditor5-table/theme/table.css */
.ck-content .table table td,
.ck-content .table table th {
  min-width: 2em;
  padding: 0.4em;
  border: 1px solid hsl(0, 0%, 75%);
}
/* ckeditor5-table/theme/table.css */
.ck-content .table table th {
  font-weight: bold;
  background: hsla(0, 0%, 0%, 5%);
}
/* ckeditor5-table/theme/table.css */
.ck-content[dir="rtl"] .table th {
  text-align: right;
}
/* ckeditor5-table/theme/table.css */
.ck-content[dir="ltr"] .table th {
  text-align: left;
}
/* ckeditor5-page-break/theme/pagebreak.css */
.ck-content .page-break {
  position: relative;
  clear: both;
  padding: 5px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
/* ckeditor5-page-break/theme/pagebreak.css */
.ck-content .page-break::after {
  content: "";
  position: absolute;
  border-bottom: 2px dashed hsl(0, 0%, 77%);
  width: 100%;
}
/* ckeditor5-page-break/theme/pagebreak.css */
.ck-content .page-break__label {
  position: relative;
  z-index: 1;
  padding: 0.3em 0.6em;
  display: block;
  text-transform: uppercase;
  border: 1px solid hsl(0, 0%, 77%);
  border-radius: 2px;
  font-family: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;
  font-size: 0.75em;
  font-weight: bold;
  color: hsl(0, 0%, 20%);
  background: hsl(0, 0%, 100%);
  box-shadow: 2px 2px 1px hsla(0, 0%, 0%, 0.15);
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/* ckeditor5-media-embed/theme/mediaembed.css */
.ck-content .media {
  clear: both;
  margin: 0.9em 0;
  display: block;
  min-width: 15em;
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list {
  list-style: none;
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list li {
  margin-bottom: 5px;
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list li .todo-list {
  margin-top: 5px;
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list .todo-list__label > input {
  -webkit-appearance: none;
  display: inline-block;
  position: relative;
  width: var(--ck-todo-list-checkmark-size);
  height: var(--ck-todo-list-checkmark-size);
  vertical-align: middle;
  border: 0;
  left: -25px;
  margin-right: -15px;
  right: 0;
  margin-left: 0;
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list .todo-list__label > input::before {
  display: block;
  position: absolute;
  box-sizing: border-box;
  content: "";
  width: 100%;
  height: 100%;
  border: 1px solid hsl(0, 0%, 20%);
  border-radius: 2px;
  transition: 250ms ease-in-out box-shadow, 250ms ease-in-out background, 250ms ease-in-out border;
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list .todo-list__label > input::after {
  display: block;
  position: absolute;
  box-sizing: content-box;
  pointer-events: none;
  content: "";
  left: calc(var(--ck-todo-list-checkmark-size) / 3);
  top: calc(var(--ck-todo-list-checkmark-size) / 5.3);
  width: calc(var(--ck-todo-list-checkmark-size) / 5.3);
  height: calc(var(--ck-todo-list-checkmark-size) / 2.6);
  border-style: solid;
  border-color: transparent;
  border-width: 0 calc(var(--ck-todo-list-checkmark-size) / 8)
    calc(var(--ck-todo-list-checkmark-size) / 8) 0;
  transform: rotate(45deg);
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list .todo-list__label > input[checked]::before {
  background: hsl(126, 64%, 41%);
  border-color: hsl(126, 64%, 41%);
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list .todo-list__label > input[checked]::after {
  border-color: hsl(0, 0%, 100%);
}
/* ckeditor5-list/theme/todolist.css */
.ck-content .todo-list .todo-list__label .todo-list__label__description {
  vertical-align: middle;
}
/* ckeditor5-language/theme/language.css */
.ck-content span[lang] {
  font-style: italic;
}
/* ckeditor5-code-block/theme/codeblock.css */
.ck-content pre {
  padding: 1em;
  color: hsl(0, 0%, 20.8%);
  background: hsla(0, 0%, 78%, 0.3);
  border: 1px solid hsl(0, 0%, 77%);
  border-radius: 2px;
  text-align: left;
  direction: ltr;
  tab-size: 4;
  white-space: pre-wrap;
  font-style: normal;
  min-width: 200px;
}
/* ckeditor5-code-block/theme/codeblock.css */
.ck-content pre code {
  background: unset;
  padding: 0;
  border-radius: 0;
}
/* ckeditor5-mention/theme/mention.css */
.ck-content .mention {
  background: var(--ck-color-mention-background);
  color: var(--ck-color-mention-text);
}
@media print {
  /* ckeditor5-page-break/theme/pagebreak.css */
  .ck-content .page-break {
    padding: 0;
  }
  /* ckeditor5-page-break/theme/pagebreak.css */
  .ck-content .page-break::after {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./public/ckeditor-content-style.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,oDAAoD;EACpD,8CAA8C;EAC9C,wDAAwD;EACxD,4CAA4C;EAC5C,oDAAoD;EACpD,8CAA8C;EAC9C,8CAA8C;EAC9C,+CAA+C;EAC/C,8CAA8C;EAC9C,+CAA+C;EAC/C,6CAA6C;EAC7C,wCAAwC;EACxC,+BAA+B;EAC/B,wEAAwE;EACxE,mCAAmC;AACrC;;AAEA,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,oBAAoB;EACpB,sBAAsB;EACtB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;AACA,yCAAyC;AACzC;;EAEE,qDAAqD;AACvD;AACA,yCAAyC;AACzC;;EAEE,WAAW;AACb;AACA,yCAAyC;AACzC;EACE,YAAY;EACZ,0CAA0C;EAC1C,cAAc;AAChB;AACA,yCAAyC;AACzC;EACE,WAAW;EACX,2CAA2C;AAC7C;AACA,yCAAyC;AACzC;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA,yCAAyC;AACzC;EACE,YAAY;EACZ,0CAA0C;AAC5C;AACA,yCAAyC;AACzC;EACE,eAAe;EACf,iBAAiB;AACnB;AACA,yCAAyC;AACzC;EACE,cAAc;EACd,kBAAkB;AACpB;AACA,yCAAyC;AACzC;;;EAGE,aAAa;AACf;AACA,yCAAyC;AACzC;;EAEE,gDAAgD;EAChD,mDAAmD;AACrD;AACA,yCAAyC;AACzC;EACE,kDAAkD;AACpD;AACA,yCAAyC;AACzC;EACE,iDAAiD;AACnD;AACA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,iBAAiB;AACnB;AACA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;AACA,4CAA4C;AAC5C;EACE,mDAAmD;AACrD;AACA,4CAA4C;AAC5C;EACE,kDAAkD;AACpD;AACA,4CAA4C;AAC5C;EACE,iDAAiD;AACnD;AACA,4CAA4C;AAC5C;EACE,iDAAiD;AACnD;AACA,4CAA4C;AAC5C;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA,4CAA4C;AAC5C;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;AACA,uDAAuD;AACvD;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,SAAS;AACX;AACA,oCAAoC;AACpC;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;AACA,oCAAoC;AACpC;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;AACA,oCAAoC;AACpC;EACE;;;;MAII;EACJ,oBAAoB;EACpB,eAAe;EACf,uBAAuB;AACzB;AACA,oCAAoC;AACpC;EACE,aAAa;AACf;AACA,oCAAoC;AACpC;;EAEE,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;AACA,0CAA0C;AAC1C;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;AACA,0CAA0C;AAC1C;EACE,WAAW;AACb;AACA,0CAA0C;AAC1C;EACE,cAAc;AAChB;AACA,+CAA+C;AAC/C;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,sCAAsC;AACxC;AACA,+CAA+C;AAC/C;EACE,cAAc;EACd,uCAAuC;AACzC;AACA,0CAA0C;AAC1C;EACE,uCAAuC;EACvC,eAAe;EACf,kBAAkB;AACpB;AACA,2CAA2C;AAC3C;EACE,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,0DAA0D;EAC1D,cAAc;EACd,iBAAiB;EACjB,oBAAoB;AACtB;AACA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,cAAc;AAChB;AACA,oCAAoC;AACpC;EACE,yBAAyB;EACzB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;AACA,oCAAoC;AACpC;;EAEE,cAAc;EACd,cAAc;EACd,iCAAiC;AACnC;AACA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,+BAA+B;AACjC;AACA,oCAAoC;AACpC;EACE,iBAAiB;AACnB;AACA,oCAAoC;AACpC;EACE,gBAAgB;AAClB;AACA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;AACb;AACA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,cAAc;EACd,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,0DAA0D;EAC1D,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,4BAA4B;EAC5B,6CAA6C;EAC7C,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;AACA,+CAA+C;AAC/C;EACE,WAAW;EACX,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA,sCAAsC;AACtC;EACE,gBAAgB;AAClB;AACA,sCAAsC;AACtC;EACE,kBAAkB;AACpB;AACA,sCAAsC;AACtC;EACE,eAAe;AACjB;AACA,sCAAsC;AACtC;EACE,wBAAwB;EACxB,qBAAqB;EACrB,kBAAkB;EAClB,yCAAyC;EACzC,0CAA0C;EAC1C,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;AACA,sCAAsC;AACtC;EACE,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,gGAAgG;AAClG;AACA,sCAAsC;AACtC;EACE,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,oBAAoB;EACpB,WAAW;EACX,kDAAkD;EAClD,mDAAmD;EACnD,qDAAqD;EACrD,sDAAsD;EACtD,mBAAmB;EACnB,yBAAyB;EACzB;kDACgD;EAChD,wBAAwB;AAC1B;AACA,sCAAsC;AACtC;EACE,8BAA8B;EAC9B,gCAAgC;AAClC;AACA,sCAAsC;AACtC;EACE,8BAA8B;AAChC;AACA,sCAAsC;AACtC;EACE,sBAAsB;AACxB;AACA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;AACA,6CAA6C;AAC7C;EACE,YAAY;EACZ,wBAAwB;EACxB,iCAAiC;EACjC,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,UAAU;EACV,gBAAgB;AAClB;AACA,wCAAwC;AACxC;EACE,8CAA8C;EAC9C,mCAAmC;AACrC;AACA;EACE,6CAA6C;EAC7C;IACE,UAAU;EACZ;EACA,6CAA6C;EAC7C;IACE,aAAa;EACf;AACF","sourcesContent":["/*\n * CKEditor 5 (v31.1.0) content styles.\n * Generated on Wed, 22 Dec 2021 12:18:23 GMT.\n * For more information, check out https://ckeditor.com/docs/ckeditor5/latest/builds/guides/integration/content-styles.html\n */\n\n:root {\n  --ck-color-image-caption-background: hsl(0, 0%, 97%);\n  --ck-color-image-caption-text: hsl(0, 0%, 20%);\n  --ck-color-mention-background: hsla(341, 100%, 30%, 0.1);\n  --ck-color-mention-text: hsl(341, 100%, 30%);\n  --ck-color-table-caption-background: hsl(0, 0%, 97%);\n  --ck-color-table-caption-text: hsl(0, 0%, 20%);\n  --ck-highlight-marker-blue: hsl(201, 97%, 72%);\n  --ck-highlight-marker-green: hsl(120, 93%, 68%);\n  --ck-highlight-marker-pink: hsl(345, 96%, 73%);\n  --ck-highlight-marker-yellow: hsl(60, 97%, 73%);\n  --ck-highlight-pen-green: hsl(112, 100%, 27%);\n  --ck-highlight-pen-red: hsl(0, 85%, 49%);\n  --ck-image-style-spacing: 1.5em;\n  --ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n  --ck-todo-list-checkmark-size: 16px;\n}\n\n/* ckeditor5-image/theme/imagecaption.css */\n.ck-content .image > figcaption {\n  display: table-caption;\n  caption-side: bottom;\n  word-break: break-word;\n  color: var(--ck-color-image-caption-text);\n  background-color: var(--ck-color-image-caption-background);\n  padding: 0.6em;\n  font-size: 0.75em;\n  outline-offset: -1px;\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-style-block-align-left,\n.ck-content .image-style-block-align-right {\n  max-width: calc(100% - var(--ck-image-style-spacing));\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-style-align-left,\n.ck-content .image-style-align-right {\n  clear: none;\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-style-side {\n  float: right;\n  margin-left: var(--ck-image-style-spacing);\n  max-width: 50%;\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-style-align-left {\n  float: left;\n  margin-right: var(--ck-image-style-spacing);\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-style-align-center {\n  margin-left: auto;\n  margin-right: auto;\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-style-align-right {\n  float: right;\n  margin-left: var(--ck-image-style-spacing);\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-style-block-align-right {\n  margin-right: 0;\n  margin-left: auto;\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-style-block-align-left {\n  margin-left: 0;\n  margin-right: auto;\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content p + .image-style-align-left,\n.ck-content p + .image-style-align-right,\n.ck-content p + .image-style-side {\n  margin-top: 0;\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-inline.image-style-align-left,\n.ck-content .image-inline.image-style-align-right {\n  margin-top: var(--ck-inline-image-style-spacing);\n  margin-bottom: var(--ck-inline-image-style-spacing);\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-inline.image-style-align-left {\n  margin-right: var(--ck-inline-image-style-spacing);\n}\n/* ckeditor5-image/theme/imagestyle.css */\n.ck-content .image-inline.image-style-align-right {\n  margin-left: var(--ck-inline-image-style-spacing);\n}\n/* ckeditor5-font/theme/fontsize.css */\n.ck-content .text-tiny {\n  font-size: 0.7em;\n}\n/* ckeditor5-font/theme/fontsize.css */\n.ck-content .text-small {\n  font-size: 0.85em;\n}\n/* ckeditor5-font/theme/fontsize.css */\n.ck-content .text-big {\n  font-size: 1.4em;\n}\n/* ckeditor5-font/theme/fontsize.css */\n.ck-content .text-huge {\n  font-size: 1.8em;\n}\n/* ckeditor5-highlight/theme/highlight.css */\n.ck-content .marker-yellow {\n  background-color: var(--ck-highlight-marker-yellow);\n}\n/* ckeditor5-highlight/theme/highlight.css */\n.ck-content .marker-green {\n  background-color: var(--ck-highlight-marker-green);\n}\n/* ckeditor5-highlight/theme/highlight.css */\n.ck-content .marker-pink {\n  background-color: var(--ck-highlight-marker-pink);\n}\n/* ckeditor5-highlight/theme/highlight.css */\n.ck-content .marker-blue {\n  background-color: var(--ck-highlight-marker-blue);\n}\n/* ckeditor5-highlight/theme/highlight.css */\n.ck-content .pen-red {\n  color: var(--ck-highlight-pen-red);\n  background-color: transparent;\n}\n/* ckeditor5-highlight/theme/highlight.css */\n.ck-content .pen-green {\n  color: var(--ck-highlight-pen-green);\n  background-color: transparent;\n}\n/* ckeditor5-horizontal-line/theme/horizontalline.css */\n.ck-content hr {\n  margin: 15px 0;\n  height: 4px;\n  background: hsl(0, 0%, 87%);\n  border: 0;\n}\n/* ckeditor5-image/theme/image.css */\n.ck-content .image {\n  display: table;\n  clear: both;\n  text-align: center;\n  margin: 0.9em auto;\n  min-width: 50px;\n}\n/* ckeditor5-image/theme/image.css */\n.ck-content .image img {\n  display: block;\n  margin: 0 auto;\n  max-width: 100%;\n  min-width: 100%;\n}\n/* ckeditor5-image/theme/image.css */\n.ck-content .image-inline {\n  /*\n     * Normally, the .image-inline would have \"display: inline-block\" and \"img { width: 100% }\" (to follow the wrapper while resizing).;\n     * Unfortunately, together with \"srcset\", it gets automatically stretched up to the width of the editing root.\n     * This strange behavior does not happen with inline-flex.\n     */\n  display: inline-flex;\n  max-width: 100%;\n  align-items: flex-start;\n}\n/* ckeditor5-image/theme/image.css */\n.ck-content .image-inline picture {\n  display: flex;\n}\n/* ckeditor5-image/theme/image.css */\n.ck-content .image-inline picture,\n.ck-content .image-inline img {\n  flex-grow: 1;\n  flex-shrink: 1;\n  max-width: 100%;\n}\n/* ckeditor5-image/theme/imageresize.css */\n.ck-content .image.image_resized {\n  max-width: 100%;\n  display: block;\n  box-sizing: border-box;\n}\n/* ckeditor5-image/theme/imageresize.css */\n.ck-content .image.image_resized img {\n  width: 100%;\n}\n/* ckeditor5-image/theme/imageresize.css */\n.ck-content .image.image_resized > figcaption {\n  display: block;\n}\n/* ckeditor5-block-quote/theme/blockquote.css */\n.ck-content blockquote {\n  overflow: hidden;\n  padding-right: 1.5em;\n  padding-left: 1.5em;\n  margin-left: 0;\n  margin-right: 0;\n  font-style: italic;\n  border-left: solid 5px hsl(0, 0%, 80%);\n}\n/* ckeditor5-block-quote/theme/blockquote.css */\n.ck-content[dir=\"rtl\"] blockquote {\n  border-left: 0;\n  border-right: solid 5px hsl(0, 0%, 80%);\n}\n/* ckeditor5-basic-styles/theme/code.css */\n.ck-content code {\n  background-color: hsla(0, 0%, 78%, 0.3);\n  padding: 0.15em;\n  border-radius: 2px;\n}\n/* ckeditor5-table/theme/tablecaption.css */\n.ck-content .table > figcaption {\n  display: table-caption;\n  caption-side: top;\n  word-break: break-word;\n  text-align: center;\n  color: var(--ck-color-table-caption-text);\n  background-color: var(--ck-color-table-caption-background);\n  padding: 0.6em;\n  font-size: 0.75em;\n  outline-offset: -1px;\n}\n/* ckeditor5-table/theme/table.css */\n.ck-content .table {\n  margin: 0.9em auto;\n  display: table;\n}\n/* ckeditor5-table/theme/table.css */\n.ck-content .table table {\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n  height: 100%;\n  border: 1px double hsl(0, 0%, 70%);\n}\n/* ckeditor5-table/theme/table.css */\n.ck-content .table table td,\n.ck-content .table table th {\n  min-width: 2em;\n  padding: 0.4em;\n  border: 1px solid hsl(0, 0%, 75%);\n}\n/* ckeditor5-table/theme/table.css */\n.ck-content .table table th {\n  font-weight: bold;\n  background: hsla(0, 0%, 0%, 5%);\n}\n/* ckeditor5-table/theme/table.css */\n.ck-content[dir=\"rtl\"] .table th {\n  text-align: right;\n}\n/* ckeditor5-table/theme/table.css */\n.ck-content[dir=\"ltr\"] .table th {\n  text-align: left;\n}\n/* ckeditor5-page-break/theme/pagebreak.css */\n.ck-content .page-break {\n  position: relative;\n  clear: both;\n  padding: 5px 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n/* ckeditor5-page-break/theme/pagebreak.css */\n.ck-content .page-break::after {\n  content: \"\";\n  position: absolute;\n  border-bottom: 2px dashed hsl(0, 0%, 77%);\n  width: 100%;\n}\n/* ckeditor5-page-break/theme/pagebreak.css */\n.ck-content .page-break__label {\n  position: relative;\n  z-index: 1;\n  padding: 0.3em 0.6em;\n  display: block;\n  text-transform: uppercase;\n  border: 1px solid hsl(0, 0%, 77%);\n  border-radius: 2px;\n  font-family: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n  font-size: 0.75em;\n  font-weight: bold;\n  color: hsl(0, 0%, 20%);\n  background: hsl(0, 0%, 100%);\n  box-shadow: 2px 2px 1px hsla(0, 0%, 0%, 0.15);\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n/* ckeditor5-media-embed/theme/mediaembed.css */\n.ck-content .media {\n  clear: both;\n  margin: 0.9em 0;\n  display: block;\n  min-width: 15em;\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list {\n  list-style: none;\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list li {\n  margin-bottom: 5px;\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list li .todo-list {\n  margin-top: 5px;\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list .todo-list__label > input {\n  -webkit-appearance: none;\n  display: inline-block;\n  position: relative;\n  width: var(--ck-todo-list-checkmark-size);\n  height: var(--ck-todo-list-checkmark-size);\n  vertical-align: middle;\n  border: 0;\n  left: -25px;\n  margin-right: -15px;\n  right: 0;\n  margin-left: 0;\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list .todo-list__label > input::before {\n  display: block;\n  position: absolute;\n  box-sizing: border-box;\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  border: 1px solid hsl(0, 0%, 20%);\n  border-radius: 2px;\n  transition: 250ms ease-in-out box-shadow, 250ms ease-in-out background, 250ms ease-in-out border;\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list .todo-list__label > input::after {\n  display: block;\n  position: absolute;\n  box-sizing: content-box;\n  pointer-events: none;\n  content: \"\";\n  left: calc(var(--ck-todo-list-checkmark-size) / 3);\n  top: calc(var(--ck-todo-list-checkmark-size) / 5.3);\n  width: calc(var(--ck-todo-list-checkmark-size) / 5.3);\n  height: calc(var(--ck-todo-list-checkmark-size) / 2.6);\n  border-style: solid;\n  border-color: transparent;\n  border-width: 0 calc(var(--ck-todo-list-checkmark-size) / 8)\n    calc(var(--ck-todo-list-checkmark-size) / 8) 0;\n  transform: rotate(45deg);\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list .todo-list__label > input[checked]::before {\n  background: hsl(126, 64%, 41%);\n  border-color: hsl(126, 64%, 41%);\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list .todo-list__label > input[checked]::after {\n  border-color: hsl(0, 0%, 100%);\n}\n/* ckeditor5-list/theme/todolist.css */\n.ck-content .todo-list .todo-list__label .todo-list__label__description {\n  vertical-align: middle;\n}\n/* ckeditor5-language/theme/language.css */\n.ck-content span[lang] {\n  font-style: italic;\n}\n/* ckeditor5-code-block/theme/codeblock.css */\n.ck-content pre {\n  padding: 1em;\n  color: hsl(0, 0%, 20.8%);\n  background: hsla(0, 0%, 78%, 0.3);\n  border: 1px solid hsl(0, 0%, 77%);\n  border-radius: 2px;\n  text-align: left;\n  direction: ltr;\n  tab-size: 4;\n  white-space: pre-wrap;\n  font-style: normal;\n  min-width: 200px;\n}\n/* ckeditor5-code-block/theme/codeblock.css */\n.ck-content pre code {\n  background: unset;\n  padding: 0;\n  border-radius: 0;\n}\n/* ckeditor5-mention/theme/mention.css */\n.ck-content .mention {\n  background: var(--ck-color-mention-background);\n  color: var(--ck-color-mention-text);\n}\n@media print {\n  /* ckeditor5-page-break/theme/pagebreak.css */\n  .ck-content .page-break {\n    padding: 0;\n  }\n  /* ckeditor5-page-break/theme/pagebreak.css */\n  .ck-content .page-break::after {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
